import {
  PaymentAPI,
  PaymentError,
  PaymentProvider,
  PaymentResponse,
  PaymentState,
  ProcessPaymentOptions,
} from '../../typings/Payment'
import confirmPayment from './confirm-payment'
import pollPayment from './poll-payment'

const handleSepaPayment = async (
  paymentProvider: PaymentProvider,
  paymentAPI: PaymentAPI,
  {
    orderId,
    selectedPaymentMethod,
    user,
    ibanElement,
    payment: { paymentIntent, id: paymentId },
  }: ProcessPaymentOptions,
  lastPaymentAttempt: Date,
): Promise<PaymentResponse> => {
  if (!paymentIntent) {
    throw new Error('Payment intent was not correctly defined')
  }

  let { pspPaymentMethodId } = selectedPaymentMethod

  if (selectedPaymentMethod.bankAccountHolder) {
    if (!ibanElement) {
      throw new Error('Iban element was not correctly defined for a new iban payment')
    }

    const { source: createdSource, error } = await paymentProvider.stripe!.createSource(ibanElement, {
      type: 'sepa_debit',
      currency: paymentIntent.currency,
      owner: {
        // TODO: remove empty string props and maybe also null
        name: selectedPaymentMethod.bankAccountHolder,
        email: user.email,
      },
      mandate: {
        notification_method: 'email',
      },
      metadata: {
        paymentIntent: paymentIntent.id,
      },
    })

    if (error) {
      return { wasSuccessful: false, error: error.message }
    }

    if (!createdSource) {
      return { wasSuccessful: false, error: PaymentError.PAYMENT_ERROR_STRIPE_SOURCE }
    }

    pspPaymentMethodId = createdSource.id
  }

  if (!pspPaymentMethodId) {
    throw new Error('No existing bank account')
  }

  const confirmPaymentResult = await confirmPayment(paymentAPI, { pspPaymentMethodId, paymentId })
  if (confirmPaymentResult.__typename === 'ExpectedErrors') {
    return { wasSuccessful: false, error: confirmPaymentResult.errors[0].message }
  }

  // the payment state can either transition to
  // - `ON_HOLD` if a mandate was created initially or to
  // - `IN_PROGRESS` if the verified mandate is charge immediately
  return pollPayment(paymentAPI, {
    orderId,
    lastPaymentAttempt,
    additionalExpectedPaymentStates: [PaymentState.PAYMENT_STATE_ON_HOLD, PaymentState.PAYMENT_STATE_IN_PROGRESS],
  })
}

export default handleSepaPayment
